import { useGetUserPhotos, useLogout } from "@/tanstack-hooks";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { User, Settings, LogOut, UserIcon } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";

export default function ProfileButton() {
  const { data: photosData, isLoading, isError } = useGetUserPhotos();
  const logoutMutation = useLogout();
  const t = useTranslation();

  const profilePhotoUrl =
    photosData && photosData.length > 0 ? photosData[0].medium_url : null;

  function handleSignOut() {
    logoutMutation.mutate({});
  }

  if (isLoading) {
    return (
      <Avatar className="animate-pulse w-9 h-9 md:h-10 md:w-10">
        <AvatarFallback>
          <UserIcon size={20} className="text-gray-400" />
        </AvatarFallback>
      </Avatar>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Avatar className="cursor-pointer hover:opacity-90 w-9 h-9 md:h-10 md:w-10">
          {profilePhotoUrl && !isError ? (
            <AvatarImage
              src={profilePhotoUrl}
              alt="profileImage"
              className="object-cover scale-125"
            />
          ) : null}
          <AvatarFallback>
            <UserIcon size={20} />
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="dark rounded-2xl">
        <NavLink to="/profile">
          <DropdownMenuItem className="gap-5 py-3 rounded-xl hover:cursor-pointer">
            <User size={16} />
            <span>{t.PROFILE_MENU.PROFILE}</span>
          </DropdownMenuItem>
        </NavLink>
        <NavLink to="/settings">
          <DropdownMenuItem className="gap-5 py-3 rounded-xl hover:cursor-pointer">
            <Settings size={16} />
            <span>{t.PROFILE_MENU.ACCOUNT}</span>
          </DropdownMenuItem>
        </NavLink>
        <DropdownMenuItem
          className="gap-5 py-3 rounded-xl hover:cursor-pointer"
          onClick={handleSignOut}
        >
          <LogOut size={16} />
          <span>{t.PROFILE_MENU.SIGN_OUT}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
